/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuer,
  UserSessionIssuer$inboundSchema,
} from "./usersessionissuer.js";

/**
 * What moving a user_session_issuer onto or off the authentication host changes for its clients.
 */
export type UserSessionIssuerAuthenticationHostImpact = {
  /**
   * Where clients sign in after the move, in the same terms.
   */
  authorizationServerAfter: string;
  /**
   * Where clients sign in now: the shared authorization server's issuer URL, or the origin that announces each MCP server's own authorization server. Empty for a shared issuer this deployment does not serve.
   */
  authorizationServerBefore: string;
  /**
   * Whether the move changes where clients sign in. False when the issuer is already where it would move.
   */
  changes: boolean;
  /**
   * A user_session_issuer record.
   */
  issuer: UserSessionIssuer;
  /**
   * Live MCP servers, toolsets, and meta MCP servers attached to the issuer. Those on a custom domain keep announcing their own authorization servers there.
   */
  mcpServerCount: number;
};

/** @internal */
export const UserSessionIssuerAuthenticationHostImpact$inboundSchema:
  z.ZodMiniType<UserSessionIssuerAuthenticationHostImpact, unknown> = z.pipe(
    z.object({
      authorization_server_after: z.string(),
      authorization_server_before: z.string(),
      changes: z.boolean(),
      issuer: UserSessionIssuer$inboundSchema,
      mcp_server_count: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "authorization_server_after": "authorizationServerAfter",
        "authorization_server_before": "authorizationServerBefore",
        "mcp_server_count": "mcpServerCount",
      });
    }),
  );

export function userSessionIssuerAuthenticationHostImpactFromJSON(
  jsonString: string,
): SafeParseResult<
  UserSessionIssuerAuthenticationHostImpact,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      UserSessionIssuerAuthenticationHostImpact$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'UserSessionIssuerAuthenticationHostImpact' from JSON`,
  );
}
